import PropTypes from 'prop-types';
import React from 'react';

import CCModal from './CCModal';

class CCModalContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isCancellationInProgress: false,
      clientProceed: false,
    };
  }

  handleClose = () => {
    if (!this.state.isCancellationInProgress) {
      this.props.onClose();
    }
  };

  handleClientProceed = () => {
    if (this.state.clientProceed === false) {
      this.props.onClose();
    }
  };

  render() {
    return (
      <CCModal
        onClose={this.handleClose}
        onPrimaryButtonClick={this.handleCancellationRequest}
        onSecondaryButtonClick={this.handleClose}
        onSend={this.props.onSend}
        clientId={this.props.clientId}
      />
    );
  }
}

CCModalContainer.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSend: PropTypes.func.isRequired,
  clientId: PropTypes.string.isRequired,
};

export default CCModalContainer;
